module.exports = __webpack_public_path__ + "static/img/0003.559313e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/0003.jpg
// module id = syAA
// module chunks = 1